import { GlobalWorkerOptions } from 'pdfjs-dist';
import { PDF_CONFIG } from './config';

let initialized = false;

export function initializePDFJS(): void {
  if (initialized) return;

  try {
    // Set worker source
    const workerSrc = new URL(
      'pdfjs-dist/build/pdf.worker.mjs',
      import.meta.url
    ).href;
    GlobalWorkerOptions.workerSrc = workerSrc;

    // Configure worker options
    GlobalWorkerOptions.workerPort = null;
    GlobalWorkerOptions.verbosity = 0;

    initialized = true;
  } catch (error) {
    console.error('Failed to initialize PDF.js:', error);
    throw new Error('PDF.js initialization failed');
  }
}

// Initialize immediately
initializePDFJS();